var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 12.25V13.35C17.75 14.8901 17.75 15.6602 17.4503 16.2485C17.1866 16.7659 16.7659 17.1866 16.2485 17.4503C15.6602 17.75 14.8901 17.75 13.35 17.75H5.65C4.10986 17.75 3.33978 17.75 2.75153 17.4503C2.23408 17.1866 1.81338 16.7659 1.54973 16.2485C1.25 15.6602 1.25 14.8901 1.25 13.35V12.25M14.0833 5.83333L9.5 1.25M9.5 1.25L4.91667 5.83333M9.5 1.25V12.25",
    stroke: "#1439BB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadfile);
export default __webpack_public_path__ + "static/media/uploadfile.6f4230687edbe8edfe4beb7f5cca65a9.svg";
export { ForwardRef as ReactComponent };